// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"465":"77bd8235","610":"247ff58c"}[chunkId] + ".css";
};